import * as CONFIG from './config';


exports.getResolution = function (id) {
    // console.log("getResolution==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/resolution/resolutionsDetails' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getResolutionList = function (id) {
    // console.log("getResolutionList==>", id);
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Resolution - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Resolution Attendee","status": "active"},{"id": 23,"name": "Alpha Resolution Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Resolution","status": "active"}]}');
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/resolution/allResolutions' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addResolution = function (objModel) {
    // console.log("addResolution==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/resolution/create', objModel)
            .then(function (response) {
                // console.log('addResolution succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addResolution err==>',err);
                reject(err);
            });
    });
}

exports.updateResolution = function (objModel) {
    // console.log("updateResolution==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/resolution/update', objModel)
            .then(function (response) {
                // console.log('updateResolution succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateResolution err==>',err);
                reject(err);
            });
    });
}

exports.updateFile = function (id, objModel) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPostFile('/resolution/updateExistingFile' + param, objModel)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteFile = function (id) {
    // console.log("deleteFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/resolution/deleteResolutionFile' + param)
            .then(function (response) {
                // console.log('deleteFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteOrCloseResolution = function (id, status) {
    // console.log("deleteResolution==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        if (status && String(status).length > 0)
            param = param + '/' + status;
        return CONFIG.httpPost('/resolution/deleteOrClose' + param)
            .then(function (response) {
                // console.log('deleteResolution succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteResolution err==>',err);
                reject(err);
            });
    });
}




// WEBPACK FOOTER //
// ./api/resolutiondetails.js